// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220350/js/" + chunkId + "." + {"44":"7e069934","225":"e418065d","481":"19803a81","486":"d0f422b2","770":"2ec28107"}[chunkId] + ".0.10390366425284692.chunk.js";
};